import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '@/pages/index/index.vue';
import ImpactFactorManagment from '@/pages/Impact-Factor-Managment/impactFactorManagment.vue';
import JournalEvaluationManagement from '@/pages/Journal-Evaluation-and-Management/jem.vue';
import QualifiedAuthorTargeting from '@/pages/Qualified-Author-Targeting/qualifiedAuthorTargeting.vue';
import UpdatedJournalLists from '@/pages/Updated-Journal-Lists/journalList.vue';
import JournalDetails from '@/pages/Updated-Journal-Lists/journalDetails.vue';
import DynamicJournalImpactFactor from '@/pages/Dynamic-Journal-Impact-Factor/dynamicJournalImpactFactor.vue';
import Blog from '@/pages/blog/blog.vue';
import BlogDetail from '@/pages/blog/BlogDetail.vue';
import ContactUs from '@/pages/ContactUs/contactus.vue';
import ReCheck from '@/pages/ReCheck/index.vue'
import IndexNews from '@/pages/ReCheck/components/news.vue';
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: {
            path: '/index'
        }
    },
    {
        path: '/index',
        component: Index,
        meta: { title: '箭弩学术 - 首页', titleEn: 'JDC - Home' }
    },
    {
        path: '/Journal-Evaluation-and-Management',
        component: JournalEvaluationManagement,
        meta: { title: '箭弩学术 - 期刊评估与管理', titleEn: 'JDC - Journal Evaluation Management' }
    },
    {
        path: '/Impact-Factor-Managment',
        component: ImpactFactorManagment,
        meta: { title: '箭弩学术 - 影响因子管理', titleEn: 'JDC - Impact Factor Managment' }
    },
    {
        path: '/Qualified-Author-Targeting',
        component: QualifiedAuthorTargeting,
        meta: { title: '箭弩学术 - 目标作者匹配', titleEn: 'JDC - Qualified Author Targeting' }
    },
    {
        path: '/Updated-Journal-Lists',
        component: UpdatedJournalLists,
        meta: { title: '箭弩学术 - 每月期刊数据更新', titleEn: 'JDC - Updated Journal Lists',keepAlive: true }
    },
    {
        path: '/Journal-Details',
        component: JournalDetails,
        meta: { title: '箭弩学术 - 期刊详情', titleEn: 'JDC - Journal Details' }
    },
    {
        path: '/Dynamic-Journal-Impact-Factor',
        component: DynamicJournalImpactFactor,
        meta: { title: '箭弩学术 - 实时影响因子', titleEn: 'JDC - Dynamic Journal Impact Factor' }
    },
    {
        path: '/Blog',
        component: Blog,
        meta: { title: '箭弩学术 - 博客', titleEn: 'JDC - Blog' }
    },
    {
        path: '/BlogDetail',
        component: BlogDetail,
        meta: { title: '箭弩学术 - 博客详情', titleEn: 'JDC - Blog Detail' }
    },
    {
        path: '/Contact-Us',
        component: ContactUs,
        meta: { title: '箭弩学术 - 联系我们', titleEn: 'JDC - Contact Us' }
    },
    {
        path: '/recheck-ai',
        component: ReCheck,
        meta: { title: '箭弩学术 - ReCheck', titleEn: 'JDC - ReCheck' }
    },
    {
        path: '/news',
        component: IndexNews,
        meta: { title: '箭弩学术 - ReCheck News', titleEn: 'JDC - ReCheck News' }
    }
];

const router = new VueRouter({
   mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

// 解决菜单 push 或 replace 重复点击报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

// 添加浏览器标签标题
router.beforeEach((to, from, next) => {
    const lang = localStorage.getItem('lang') || 'zh'; // 默认使用中文
    if (lang === 'zh') {
        document.title = to.meta.title || '默认标题';
    } else if (lang === 'en') {
        document.title = to.meta.titleEn || '默认标题';
    }
    next();
});

export default router;